import React from 'react';
import TransactionList from '@/components/transaction/list';

export default () => <TransactionList />;
